// extracted by mini-css-extract-plugin
module.exports = {"homeLayoutGrid":"home-layout_component_homeLayoutGrid__KsR0z"};